module.exports = __webpack_public_path__ + "media/img/description/galaxy-sm-aefe25c0069109e7a9fee64c58f88350.svg";